import { forwardRef, useImperativeHandle, useRef } from 'react'

import cn from 'clsx'

import { CrossCircleIcon } from '@App/static/icons/InputComponentIcons'

import s from './styles.module.scss'

type Props = {
  containerClassName?: string
  leftIcon?: React.ReactNode
  cleareable?: boolean
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export const TextField = forwardRef<HTMLInputElement, Props>(
  ({ containerClassName, className, leftIcon, cleareable, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement)

    const handleClear = () => {
      const nativeInputValueSetter = Object?.getOwnPropertyDescriptor?.(window.HTMLInputElement.prototype, 'value')?.set

      if (nativeInputValueSetter && inputRef.current) {
        nativeInputValueSetter.call(inputRef.current, '')
        const event = new Event('input', { bubbles: true })
        inputRef.current.dispatchEvent(event)
      }
    }

    return (
      <div className={cn(s.container, containerClassName)}>
        {leftIcon}
        <input ref={inputRef} {...props} className={cn(s.input, className)} />
        {props.value && cleareable && <CrossCircleIcon className={s.clearIcon} onClick={handleClear} />}
      </div>
    )
  },
)

TextField.displayName = 'TextField'
